import React from "react";
import styled from "styled-components";
import { IonSearchbar } from "@ionic/react";
import { useTranslation } from "react-i18next";

import filterIcon from "../../../assets/MentalPlus/filtres.svg";
import saveIcon from "../../../assets/MentalPlus/save2.svg";

type Props = {
  query: string;
  onQueryChange: (value: string) => void;
  onOpenFilters: () => void;
  onOpenSaved: () => void;
};

const VideoToolbar: React.FC<Props> = ({
  query,
  onQueryChange,
  onOpenFilters,
  onOpenSaved,
}) => {
  const { t } = useTranslation();

  return (
    <TopBar>
      <BarRow>
        <SearchField>
          <IonSearchbar
            value={query}
            placeholder={t("mentalplus_video_rechercher")}
            inputmode="search"
            debounce={200}
            onIonInput={(e) => onQueryChange(e.detail.value ?? "")}
            showClearButton="focus"
            showCancelButton="never"
          />
        </SearchField>

        <IconAction onClick={onOpenFilters} aria-label={t("mentalplus_video_filtres")}>
          <IconImg src={filterIcon} alt="" />
        </IconAction>

        <IconAction onClick={onOpenSaved} aria-label={t("mentalplus_video_enregistrees")}>
          <IconImg src={saveIcon} alt="" />
        </IconAction>
      </BarRow>
    </TopBar>
  );
};

export default VideoToolbar;

const TopBar = styled.div`
  /* Sits in DisplayVideos' fixed TopArea, which paints the bar color. */
  background: transparent;
  padding: 0 12px;
`;

const BarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 6px;
  padding-bottom: 8px;
  background: transparent;
`;

const SearchField = styled.div`
  flex: 1;
  min-width: 0;

  display: flex;
  align-items: center;

  ion-searchbar {
    width: 100%;
    padding: 0;
    --border-radius: 23px;
    --background: var(--app-color-surface-tint, #f5f9fe);
    --color: var(--app-color-text, #041e32);
    --placeholder-color: rgba(var(--app-color-text-rgb, 4, 23, 35), 0.55);
    --icon-color: rgba(var(--app-color-text-rgb, 4, 23, 35), 0.55);
    --clear-button-color: rgba(var(--app-color-text-rgb, 4, 23, 35), 0.55);
    --box-shadow: none;
  }
`;

const IconAction = styled.button`
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &:active {
    transform: scale(0.95);
  }
`;

const IconImg = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
`;
